import React from 'react';
import styled from 'styled-components';
import {withRouter} from 'react-router-dom';

import {Row, Col, Button, DropdownItem } from 'reactstrap';

import  styledMagstimTableWrapper from 'common/controls/StyledMagstimTableWrapper'
import {MagstimHeaderBar, MagstimDropdown, MagstimTableTreatmentArchive, MagstimColor, magstim_clickHandler, magstim_eventHandler, isPDA, getDropdownItems, CurrentLang, CurrentTheme,  MagstimFetch, GetRange} from "common";
import { patientRoutesBase } from 'routes';

import * as CsvUtils from 'common/utils/CsvUtils';

import { REST_ENDPOINT_TREATMENT_ARCHIVE } from 'common/ApiEndpoints';

const EXPORT_FILE_NAME = 'treatment-history.csv'

class PatientTreatmentArchive extends React.Component {

	constructor() {
		super();

		this.state = {
			tableHeight: isPDA() ?  'calc(100vh - 426px)' : 'calc(100vh - 240px)',
			filterPadding: isPDA() ?  '18px' : '38px',
			selectOptions: [],
			exportDisabled: false,
			exportFileName:EXPORT_FILE_NAME
		};

		this._table = React.createRef();
		this._clinicianFilter = React.createRef();
		this._dateFilter = React.createRef();

		window._PatientTreatmentArchive_initForSelect = this.initForSelect.bind(this);
	}

	onSelectFilter = (id) => {
		this._table.current.addFilter('performedBy', id);
		this.visualiseTableData( this._table.current.getFilteredData() );
	}

	onSelectDate = (id) => {
		const range = GetRange(id);

		magstim_eventHandler('select', 'date', range);
		this._table.current.addFilter('date', range);

		this.visualiseTableData( this._table.current.getFilteredData() );
	}

	// eslint-disable-next-line no-unused-vars
	onClickExport = (event) => {
		// console.log('onClickExport');

		if(isPDA()){
			CsvUtils.downloadAsCSV(document, this.state.exportFileName, this._table.current.getColumns(), this._table.current.getFilteredData());
		}else{
			magstim_clickHandler('export', CsvUtils.toCsv(this._table.current.getColumns(), this._table.current.getFilteredData()) );
		}
	}

	cellClickCallback = (row, column, cell) => {
		console.log('cellClickCallback', row, column, cell);
		if(this.props.history){
			this.props.history.push({pathname: `${patientRoutesBase}/${this.props.match.params.PatientGuid}/Treatments/History/${row.protocolGUID}`});
		}
	}
	
	render() {

		//console.log("DATA", this.state);

		let clinicianHeaderItems = [<DropdownItem key={CurrentLang().treatment_history_all_treaters} active>{CurrentLang().treatment_history_all_treaters}</DropdownItem>, <DropdownItem key="divider" divider />];
		
		let clinicianItems = clinicianHeaderItems.concat(this.state.selectOptions.map((key, index) => (
			<DropdownItem id={this.state.selectOptions[index]}
				key={index}
				active={key === 0}
			>{this.state.selectOptions[index]}</DropdownItem>
		)));

		return (
			<Wrapper className="ui-fillh" tableHeight={this.state.tableHeight}  filterPadding={this.state.filterPadding}>
				<Row className="ui-fillh">

					<Col className="ui-fillh">
						<Row className="ui-header">
							<Col md="4" sm="12">
								<MagstimHeaderBar
									main_title={CurrentLang().patient_home_treatment_archive}
									ShowClose={false}
								/>
						  	</Col>

							<Col md="4" sm="12" className="mt-auto mb-auto filter-dropdown">
									<MagstimDropdown id="clinician" ref={this._clinicianFilter} onSelect={this.onSelectFilter}  icon='fas fa-user-md' >
										{clinicianItems}
									</MagstimDropdown>
							</Col>

							<Col md="4" sm="12" className="mt-auto mb-auto filter-dropdown">
									<MagstimDropdown id="treatmentDate" ref={this._dateFilter} onSelect={this.onSelectDate}  icon='fas fa-calendar-alt'>
										<DropdownItem key="allTime" id='allTime' active>{CurrentLang().treatment_history_date_allTime}</DropdownItem>
										<DropdownItem key="divider" divider />
										<DropdownItem key="lastWeeks4" id='lastWeeks4'>{CurrentLang().treatment_history_date_lastWeeks4}</DropdownItem>
										<DropdownItem key="lastMonths6" id='lastMonths6'>{CurrentLang().treatment_history_date_lastMonths6}</DropdownItem>
										<DropdownItem key="lastMonths12" id='lastMonths12'>{CurrentLang().treatment_history_date_lastMonths12}</DropdownItem>
									</MagstimDropdown>
							</Col>
						</Row>

						<Row className="ui-main ui-bg">
							<Col>
								<Row>
									<Col>
										<div className="table-area mt-3">
											<MagstimTableTreatmentArchive ref={this._table} div_name="tbTreatmentArchive" cellClickCallback={this.cellClickCallback} />
										</div>
									</Col>
								</Row>
								<Row>
									<Col className="pt-2 pr-4 m-3 text-right">
										<Button color="primary" disabled={this.state.exportDisabled} className="pl-5 pr-5" onClick={this.onClickExport} size={CurrentTheme().ControlSize} ><i className="fas fa-file-excel pr-2"></i> {CurrentLang().table_export_title}</Button>
									</Col>
								</Row>
							</Col>
						</Row>
					</Col>

				</Row>
			</Wrapper>
		);
	}

	componentDidMount() {
		if(isPDA()){
			this.loadDataFromAPI();
		}
	}

    loadDataFromAPI(){
		MagstimFetch.get(REST_ENDPOINT_TREATMENT_ARCHIVE, this.props.match.params.PatientGuid)
		.then((data) => {
			// console.log('loadDataFromAPI', data);
			if ((undefined !== data.items) && (null !== data.items))
				this.initForSelect(data.items);
			else
				this.initForSelect(data);

			var userNameAndID = `${data.patientDetail.FirstName} ${data.patientDetail.LastName} - ${data.patientDetail.PatientIdNum}`;
			this.setState({exportFileName: `${userNameAndID}-${EXPORT_FILE_NAME}`})
		})
		.catch((error) => {
			this.props.handleError(error);
		});
	}

	initForSelect(data) {
		if(this._table && this._table.current){
			this._table.current.initForSelect(data);
			this._table.current.resetFilters();
			this.visualiseTableData(this._table.current.getFilteredData());
		}
	}

	visualiseTableData = (data) => {
		this.setState({
			exportDisabled: (0 === data.length) || ((1 === data.length) && (undefined !== data[0].__dummy_no_data_row) && data[0].__dummy_no_data_row),
			selectOptions: getDropdownItems('tbTreatmentArchive', 'performedBy', 'performedBy')
		});

	}

	// get data from object
	getObjectData(filteredData, xKey, yKey) {

		var labels = filteredData.map(a => a.treatmentDate);
		var values = filteredData.map(a => a.rMTLevel);
		let data = [];

		for (var i = 0; i < labels.length; i++) {
			data.push({
				label: labels[i],
				value: values[i]
			});
		}

		return data;
	}

	getData(filteredData) {
		let data = [];

		data.push({
			title: 'Motor Threshold Level',
			pointBackgroundColor: 'white',
			pointBorderWidth: 2,
			pointRadius: 8,
			pointHoverBorderWidth: 2,
			pointHoverRadius: 8,
			borderWidth: 2,
			label: '',
			fill: 'start',
			showLine: true,
			data: this.getObjectData(filteredData, "treatmentDate", "rMTLevel")
		});

		return data;
	}
}

const Wrapper = styled(styledMagstimTableWrapper)`

.ui-header{
	color: ${ MagstimColor.MagstimGroupHeaderText };
	background-color: ${ MagstimColor.MagstimCardHeaderBackground };
}

.filter-dropdown{
	padding-right: ${props => props.filterPadding};
}

`;

export default isPDA() ? withRouter(PatientTreatmentArchive) : PatientTreatmentArchive;

